import { setCookie, getCookie, removeCookie } from 'react-use-cookie';
import { get } from 'lodash/fp';
import { toObjectDateRange } from '../../helpers/dates';

const cookieSettings = {
  days: 3650 // 10 years expiration
};

export const setCurrentUserCookie = (key, value, settings = cookieSettings) => {
  const userId = localStorage.getItem('userId');
  return setCookie(`${userId}.${key}`, value, settings);
};

export const getCurrentUserCookie = key => {
  const userId = localStorage.getItem('userId');
  return getCookie(`${userId}.${key}`);
};

export const removeCurrentUserCookie = key => {
  const userId = localStorage.getItem('userId');
  return removeCookie(`${userId}.${key}`);
};

export const setReservationsRememberFlagCookie = (
  context,
  value,
  settings = cookieSettings
) =>
  setCurrentUserCookie(`reservations.${context}_rememberFlag`, value, settings);

export const setReservationsSearchQueryCookie = (
  context,
  query,
  settings = cookieSettings
) =>
  setCurrentUserCookie(
    `reservations.${context}_query`,
    JSON.stringify(query),
    settings
  );

export const getReservationsRememberFlagCookie = context =>
  getCurrentUserCookie(`reservations.${context}_rememberFlag`) === '1';

export const getReservationsSearchQueryCookie = context => {
  const query = getCurrentUserCookie(`reservations.${context}_query`);
  const jsonQuery = query ? JSON.parse(query) : {};

  const requestTime = get('requestTime', jsonQuery);
  if (requestTime)
    return { ...jsonQuery, requestTime: toObjectDateRange(requestTime) };

  return jsonQuery;
};

export const setShowAvailableEventsOnlyCookie = value =>
  setCurrentUserCookie(`upcomingEvents.showAvailableEventsOnly`, value);

export const getShowAvailableEventsOnlyCookie = () =>
  getCurrentUserCookie(`upcomingEvents.showAvailableEventsOnly`);
